module.exports = __webpack_public_path__ + "img/4.46fe7482.png";